import type { SitecoreClient } from "@sitecore-content-sdk/nextjs/client";
import type { LayoutServiceData } from "@sitecore-content-sdk/nextjs";

/**
 * Fetches a partial design's `rendered` layout by item id/path.
 *
 * Mirrors the JSS `GraphQlLayoutRouteService.fetchLayoutRoute` pattern from the
 * legacy headapp:
 *   query { item(path: "<id>", language: "<lang>") { rendered } }
 *
 * Uses the SDK 2.0 `SitecoreClient.getData()` pass-through, which routes the
 * query to whichever Edge / local endpoint the client is configured for.
 */
export const fetchLayoutRouteData = async (
  client: SitecoreClient,
  routeId: string,
  language: string,
): Promise<LayoutServiceData | null> => {
  if (!routeId) return null;

  const query = `query LayoutRoute {
    item(path: "${routeId}", language: "${language}") {
      rendered
    }
  }`;

  try {
    const data = await client.getData<{
      item: { rendered: LayoutServiceData } | null;
    }>(query);
    return data?.item?.rendered ?? null;
  } catch (error) {
    console.error(
      `[layout-routes] fetch failed for routeId=${routeId} lang=${language}`,
      error,
    );
    return null;
  }
};
